import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import LukosInteractiveSolutions from '../../components/custom/LukosInteractiveSolutions/LukosInteractiveSolutions';
import { LukosAIHero, LukosAIFeatures } from '../../components/custom/LukosAIPremium/LukosAIPremium';
import { LukosConciliacaoPremium, LukosFidelidadePremium, LukosPayPremium } from '../../components/custom/LukosPremiumSolutions/LukosPremiumSolutions';
import { LukosPDVHero, LukosPDVFeatures } from '../../components/custom/LukosPDVPremium/LukosPDVPremium';

const SolucoesPage = () => {
  const [activeTab, setActiveTab] = useState('LUK');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Nav de abas — rola para a seção correspondente */}
        <LukosInteractiveSolutions
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        {/* ── Solução exibida individualmente ── */}
        <div id="solucoes-completas" className="bg-white">

          {activeTab === 'LUK' && (
            <div id="secao-luk">
              <LukosAIHero />
              <LukosAIFeatures />
            </div>
          )}

          {activeTab === 'Conciliação' && (
            <div id="secao-conciliacao">
              <LukosConciliacaoPremium />
            </div>
          )}

          {activeTab === 'PDV e Frente de Caixa' && (
            <div id="secao-pdv">
              <LukosPDVHero />
              <LukosPDVFeatures />
            </div>
          )}

          {activeTab === 'Lukos Pay' && (
            <div id="secao-pay">
              <LukosPayPremium />
            </div>
          )}

          {activeTab === 'Fidelidade' && (
            <div id="secao-fidelidade">
              <LukosFidelidadePremium />
            </div>
          )}

          {/* Botão para voltar ao topo e selecionar outra solução */}
          <div className="py-20 flex justify-center bg-white border-t border-slate-100">
            <motion.button 
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group relative flex items-center gap-3 bg-slate-900 text-white px-10 py-5 rounded-2xl font-black shadow-[0_20px_40px_-10px_rgba(0,0,0,0.2)] transition-all duration-500 uppercase tracking-[0.15em] text-xs overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="relative z-10">Voltar e ver outra solução</span>
              <ArrowRight className="relative z-10 w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" />
            </motion.button>
          </div>

        </div>
      </motion.div>
    </div>
  );
};

export default SolucoesPage;
